"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var ParityClient_1 = require("./ParityClient");
var SecretStoreClient_1 = require("./SecretStoreClient");
var SecretStore = (function () {
    function SecretStore(config) {
        this.parityClient = new ParityClient_1["default"]({
            url: config.parityUri, address: config.address,
            password: config.password
        });
        this.secretStoreClient = new SecretStoreClient_1["default"]({
            url: config.secretStoreUri,
            threshold: config.threshold
        });
    }
    SecretStore.prototype.encryptDocument = function (serverKeyId, document) {
        return __awaiter(this, void 0, void 0, function () {
            var serverKey, documentKey, encryptedDocument;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.generateServerKey(serverKeyId)];
                    case 1:
                        serverKey = _a.sent();
                        return [4, this.generateDocumentKey(serverKey)];
                    case 2:
                        documentKey = _a.sent();
                        return [4, this.storeDocumentKey(serverKeyId, documentKey)];
                    case 3:
                        _a.sent();
                        return [4, this.parityClient.encryptDocument(documentKey.encryptedKey, document)];
                    case 4:
                        encryptedDocument = _a.sent();
                        return [2, encryptedDocument];
                }
            });
        });
    };
    SecretStore.prototype.decryptDocument = function (serverKeyId, encryptedDocument) {
        return __awaiter(this, void 0, void 0, function () {
            var documentKey, decryptDocument;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.retrieveDocumentKey(serverKeyId)];
                    case 1:
                        documentKey = _a.sent();
                        return [4, this.parityClient.decryptDocument(documentKey.decryptedSecret, documentKey.commonPoint, documentKey.decryptShadows, encryptedDocument)];
                    case 2:
                        decryptDocument = _a.sent();
                        return [2, decryptDocument];
                }
            });
        });
    };
    SecretStore.prototype.generateServerKey = function (serverKeyId) {
        return __awaiter(this, void 0, void 0, function () {
            var serverKeyIdSig, serverKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.parityClient.signKeyId(serverKeyId)];
                    case 1:
                        serverKeyIdSig = _a.sent();
                        return [4, this.secretStoreClient.generateServerKey(serverKeyId, serverKeyIdSig)];
                    case 2:
                        serverKey = _a.sent();
                        return [2, serverKey];
                }
            });
        });
    };
    SecretStore.prototype.generateDocumentKey = function (serverKey) {
        return __awaiter(this, void 0, void 0, function () {
            var documentKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.parityClient.generateDocumentKeyFromServerKey(serverKey)];
                    case 1:
                        documentKeys = _a.sent();
                        return [2, documentKeys];
                }
            });
        });
    };
    SecretStore.prototype.storeDocumentKey = function (serverKeyId, documentKeys) {
        return __awaiter(this, void 0, void 0, function () {
            var serverKeyIdSig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.parityClient.signKeyId(serverKeyId)];
                    case 1:
                        serverKeyIdSig = _a.sent();
                        return [4, this.secretStoreClient.storeDocumentKey(serverKeyId, serverKeyIdSig, documentKeys.commonPoint, documentKeys.encryptedPoint)];
                    case 2:
                        _a.sent();
                        return [2, true];
                }
            });
        });
    };
    SecretStore.prototype.retrieveDocumentKey = function (serverKeyId) {
        return __awaiter(this, void 0, void 0, function () {
            var serverKeyIdSig, documentKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.parityClient.signKeyId(serverKeyId)];
                    case 1:
                        serverKeyIdSig = _a.sent();
                        return [4, this.secretStoreClient.retrieveDocumentKey(serverKeyId, serverKeyIdSig)];
                    case 2:
                        documentKeys = _a.sent();
                        return [2, documentKeys];
                }
            });
        });
    };
    return SecretStore;
}());
exports["default"] = SecretStore;
//# sourceMappingURL=SecretStore.js.map